import { Controller, type Control } from 'react-hook-form'

import AsyncSelect from '@components/molecules/AsyncSelect'
import { scopedTranslation } from '@utils/I18n'

import { roleOptionsFor, loadRoleOptions } from './options'

const t = scopedTranslation('author_shifts')
const tShift = scopedTranslation('attributes.shift')

type RoleFieldProps = {
  control: Control<any>
  name: string
  roles: string[]
  errors?: unknown
}

export function RoleField({ control, name, roles, errors }: RoleFieldProps) {
  const roleOptions = roleOptionsFor(roles)

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <div className="tw:flex tw:flex-col">
          <AsyncSelect
            field={field}
            displayName={tShift('role')}
            placeholder={t('role_placeholder')}
            noOptionsMessage={t('role_no_options')}
            errors={errors}
            defaultOptions={roleOptions}
            loadOptions={loadRoleOptions(roleOptions)}
            debounceSearch={false}
            isMulti={false}
            isCreatable
            isClearable
            menuPortalTarget={document.body}
            menuPosition="fixed"
          />
          <p className="tw:pt-1 tw:text-sm tw:text-gray-500">{t('role_hint')}</p>
        </div>
      )}
    />
  )
}
